<template>
  <v-card flat>
    <v-list two-line v-if="contents.length" class="pt-0 pb-0 video-list">

      <template v-for="(content, $indexContent) in contents">
        <v-list-item :key="$indexContent"
                     @click="selectContent(content)"
                     class="video-item"
                     v-bind:class="{'video-item-active': contentActiveId === content._id}"
        >

          <v-list-item-content class="video-list-aula"
                               :style="(content.startAt && new Date(content.startAt) > new Date() ? 'cursor: no-drop' : '')"
          >
            <v-list-item-title>
              <h4 :class="content.type === 1 ? 'title-video' : 'title-text' ">
                <font-awesome-icon :icon="['fa', 'file-alt']" v-if="content.type === 2"></font-awesome-icon>
                {{ content.title }} <em v-if="content.vimeoId && !content.duration">(Processando vídeo)</em></h4>
            </v-list-item-title>

            <span class="time" v-if="!content.startAt || new Date(content.startAt) < new Date()">
              <font-awesome-icon :icon="['fa', 'play-circle']" v-if="content.type === 1"></font-awesome-icon>
              {{ content.duration | timeVideo }}
              <!--<span class="video-concluido">Concluído</span>-->
              <span class="video-concluido" v-if="content.percentage && parseFloat(content.percentage) >= 75">
                <span class="material-icons">
                  check_circle
                </span>
              </span>

              <span class="file-content"
                    v-if="content.pdf && (!content.startAt || new Date(content.startAt) < new Date())">
                <v-btn
                  small
                  @click.native.stop="downloadPDF(content.pdf)"
                  class="file-content-btn"
                >Download</v-btn>
                <!--<v-menu offset-y nudge-top="-5">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      small
                      v-on="on"
                      class="file-content-btn"
                    >
                      Arquivos
                    </v-btn>
                  </template>
                  <v-list class="file-content-list">
                    <v-list-tile
                      v-for="(item, index) in items"
                      :key="index"
                    >
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </v-menu>-->
              </span>
            </span>

            <!-- se a aula estiver bloqueado -->
            <span class="time block-video" v-if="content.startAt && new Date(content.startAt) > new Date()">
              <font-awesome-icon :icon="['fas', 'lock']"></font-awesome-icon>
              Liberado a partir de {{ content.startAt | formatDateContent }}
            </span>

          </v-list-item-content>
        </v-list-item>
        <div :key="`file${$indexContent}`"
             v-if="content.attachments && content.attachments.length && (!content.startAt || new Date(content.startAt) < new Date())">
          <v-list-item v-for="(attachment, $indexAttachment) in content.attachments"
                       :key="`attach${$indexAttachment}`" class="item-attachment ml-4"
                       @click="downloadAttachment(attachment)">
            <v-list-item-content>
              <v-list-item-title>
                <font-awesome-icon :icon="['fa', 'download']"></font-awesome-icon>
                {{ attachment.name }}
              </v-list-item-title>
            </v-list-item-content>


            <!-- <v-list-tile-action>
              <span v-if="content.percentage">{{content.percentage}}</span>
              <v-icon class="check-video" v-if="content.percentage && parseFloat(content.percentage) >= 75">check</v-icon>
              <v-icon v-else color="yellow darken-2">star</v-icon>
            </v-list-tile-action> -->

          </v-list-item>
        </div>
      </template>
    </v-list>
  </v-card>
</template>

<script>
import { faPlayCircle, faLock, faFileAlt, faDownload } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'

library.add(faPlayCircle, faLock, faFileAlt, faDownload)

export default {
  name: 'ContentList',
  data: () => ({
    items: [
      { title: 'Arquivo1.pdf' },
      { title: 'Arquivo2.pdf' },
    ]
  }),
  props: {
    contents: {
      type: Array,
      required: true
    },
    contentActiveId: {
      type: String,
      required: false
    }
  },
  methods: {
    downloadPDF (pdf) {
      this.axios.request({
        method: 'get',
        url: `/user/content/file/${pdf}`,
        responseType: 'blob'
      }).then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'anexo.pdf')
        document.body.appendChild(link)
        link.click()
      })
    },
    downloadAttachment (attachment) {
      this.axios.request({
        method: 'get',
        url: `/user/content/file/${attachment.fileName}`,
        responseType: 'blob'
      }).then(({ data }) => {
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', attachment.fileName)
        document.body.appendChild(link)
        link.click()
      })
    },
    selectContent (content) {
      if (content.startAt && new Date(content.startAt) > new Date()) {
        return false
      }

      if (content.vimeoId && !content.duration) {
        return false
      }

      content.time = 0

      this.$emit('selectContent', content)
    }
  }
}
</script>
<style scoped>
.item-attachment {
  min-height: auto;
}
</style>
